import { motion, useAnimationFrame } from 'framer-motion';
import { useEffect, useRef } from 'react';

export function BoilingDiv({ heat, children, speed = 50 }) {
  const ref = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    if (heat < 70) {
      if (ref.current) {
        ref.current.style.transform = 'translate(0px, 0px) rotate(0deg)';
      }
      return;
    }

    // Normalize heat from 70–100 to 0–1
    const intensity = (Math.min(100, heat) - 70) / 30;

    intervalRef.current = setInterval(() => {
      if (!ref.current) return;

      const maxTranslate = 2 + 3 * intensity; // 2–10px
      const maxRotate = 10 + 8 * intensity; // 0.5–2.5deg

      const x = (Math.random() - 0.5) * maxTranslate;
      const y = (Math.random() - 0.5) * maxTranslate;
      const rotate = (Math.random() - 0.5) * maxRotate;

      ref.current.style.transform = `translate(${x}px, ${y}px) rotate(${rotate}deg)`;
    }, speed); // ← Speed in ms

    return () => clearInterval(intervalRef.current);
  }, [heat, speed]);

  return (
    <motion.div
      ref={ref}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: '0.1s',
      }}
    >
      {children}
    </motion.div>
  );
}
